import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/assets/css/reset.less';
import '@/assets/css/common.less';
import '@/assets/css/design-system.less';
import Router from '@/router/index';
import '@ant-design/v5-patch-for-react-19';
import { ConfigProvider } from 'antd';
// 由于 antd 组件的默认文案是英文，所以需要修改为中文
import zhCN from 'antd/lib/locale/zh_CN';

import axios from 'axios';
import { OpenAPI } from '@/apis';
axios.defaults.withCredentials = true;
// 配置 OpenAPI 基础地址与 Cookie 跨域
if (import.meta.env.PROD) {
  OpenAPI.BASE = '//api.sinolinkway.com';
} else {
  // 开发环境走本地代理
  OpenAPI.BASE = '';
}
OpenAPI.WITH_CREDENTIALS = true;
OpenAPI.CREDENTIALS = 'include';

// 从 localStorage 加载 token
const savedToken = localStorage.getItem('token');
if (savedToken) {
  OpenAPI.TOKEN = savedToken;
}

// 添加请求拦截器，自动添加 token
axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('token');
    if (token && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function (response) {
    if (response.data.errNo === 0) {
      return response;
    } else {
      return Promise.reject(response.data.errstr);
    }
  },
  function (error) {
    if (error.response) {
      if (error.response.status == '401') {
        window.location.replace(`/login`);
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
    }
    return Promise.reject(error);
  }
);
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          // 现代蓝紫色主色调
          colorPrimary: '#6366f1',
          colorPrimaryHover: '#4f46e5',
          colorPrimaryActive: '#4338ca',

          // 辅助色系
          colorSuccess: '#10b981',
          colorWarning: '#f59e0b',
          colorError: '#ef4444',
          colorInfo: '#06b6d4',

          // 背景色系 - 现代中性色
          colorBgContainer: '#ffffff',
          colorBgBase: '#f8fafc',
          colorBgElevated: '#ffffff',
          colorBgLayout: '#f1f5f9',

          // 文字色系
          colorText: '#1e293b',
          colorTextSecondary: '#64748b',
          colorTextTertiary: '#94a3b8',
          colorTextQuaternary: '#cbd5e1',

          // 边框和分割线
          colorBorder: '#e2e8f0',
          colorBorderSecondary: '#f1f5f9',

          // 圆角 - 更现代的圆角
          borderRadius: 8,
          borderRadiusLG: 12,
          borderRadiusSM: 6,

          // 阴影
          boxShadow:
            '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
          boxShadowSecondary:
            '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',

          // 字体
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          fontSize: 14,
          fontSizeLG: 16,
          fontSizeSM: 12,
        },
        components: {
          // Button 组件样式
          Button: {
            borderRadius: 8,
            fontWeight: 500,
            boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
          },
          // Card 组件样式
          Card: {
            borderRadius: 12,
            boxShadow:
              '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
          },
          // Input 组件样式
          Input: {
            borderRadius: 8,
            colorBorder: '#e2e8f0',
            colorPrimaryBorder: '#6366f1',
          },
          // Menu 组件样式
          Menu: {
            borderRadius: 8,
            colorItemBg: 'transparent',
            colorItemBgHover: '#f1f5f9',
            colorItemBgSelected: '#6366f1',
            colorItemTextSelected: '#ffffff',
          },
          // Table 组件样式
          Table: {
            borderRadius: 8,
            headerBg: '#f8fafc',
            headerColor: '#1e293b',
            rowHoverBg: '#f8fafc',
          },
        },
      }}
    >
      <Router />
    </ConfigProvider>
  </StrictMode>
);
